import { useLocalObservable } from 'mobx-react-lite';
import React, { createContext } from 'react';

import { useRootStore } from '@/configs/store';
import { useFavoriteUsers } from '@/features/favoriteUsers';
import { useLogsMode } from '@/features/logsMode';
import { useStrictContext } from '@/hooks/useStrictContext';

import { GlobalUserFilterModel } from './GlobalUserFilterModel';

interface ProviderProps {
  children: React.ReactNode;
}

const GlobalUserFilterContext = createContext<GlobalUserFilterModel | null>(null);

export const GlobalUserFilterProvider: React.FC<ProviderProps> = ({ children }) => {
  const { userStore, queryStore, alertsStore } = useRootStore();
  const favoriteUsersModel = useFavoriteUsers();
  const mode = useLogsMode();

  const globalUserFilterModel = useLocalObservable(
    () =>
      new GlobalUserFilterModel({
        userStore,
        queryStore,
        alertsStore,
        favoriteUsersModel,
        mode,
      }),
  );

  return (
    <GlobalUserFilterContext.Provider value={globalUserFilterModel}>
      {children}
    </GlobalUserFilterContext.Provider>
  );
};

export function useGlobalUserFilterModel() {
  const store = useStrictContext({
    context: GlobalUserFilterContext,
    message: 'useGlobalUserFilterModel must be used within GlobalUserFilterProvider',
  });

  return store;
}
